import confirmMarkAsPhishing from './helpers/confirmMarkAsPhishing';
import filterRowKeysByExistence from './helpers/filterRowKeysByExistence';
import markItemsAsPhishingBasedOnItemIds from './helpers/markItemsAsPhishingBasedOnItemIds';
import { ActionSource } from 'owa-analytics-actions';
import { userMailInteractionAction } from 'owa-mail-actions';
import deleteConversationStoreUpdate from 'owa-mail-actions/lib/triage/deleteConversationStoreUpdate';
import { getRowIdsFromRowKeys, TableView } from 'owa-mail-list-store';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import getItemIdsFromConversations from 'owa-mail-list-store/lib/utils/getItemIdsFromConversations';

/**
 * Mark the conversation as phishing with the confirm dialog
 * @param conversationRowKeys the specified conversation ids to be marked as phishing
 * @param tableView that contains the rows
 * @param actionSource the action source where this action is triggered from
 * @return a function which shows the confirmation dialog
 */
export default function markConversationsAsPhishingFromTable(
    conversationRowKeys: string[],
    tableView: TableView,
    actionSource: ActionSource
) {
    // Calls a helper method to trigger the confirm dialog before processing mark as phishing
    confirmMarkAsPhishing(() => {
        markConversationsAsPhishingInternal(conversationRowKeys, tableView, actionSource);
    });
}

/**
 * mark conversations as phishing action
 * @param conversationRowKeys rowKeys for the specified conversations
 * @param tableView the table view id
 * @param actionSource the action source where this action is triggered from
 */
function markConversationsAsPhishingInternal(
    conversationRowKeys: string[],
    tableView: TableView,
    actionSource: ActionSource
) {
    // Since rows may have been deleted from the table while the confirm dialog was open,
    // we need to validate the rows exist before proceeding
    const filteredRowKeys = filterRowKeysByExistence(conversationRowKeys, tableView);
    if (filteredRowKeys.length == 0) {
        // Nothing to remove
        return;
    }
    const instrumentationContexts = getInstrumentationContextsFromTableView(
        conversationRowKeys,
        tableView
    );

    // Get the de-duped conversation ids
    const conversationIdStrings = getRowIdsFromRowKeys(filteredRowKeys, tableView.id);

    // Get all itemIds inside the conversations
    const itemIdsToUpdate = getItemIdsFromConversations(filteredRowKeys, tableView.id);

    markItemsAsPhishingBasedOnItemIds(itemIdsToUpdate, tableView, actionSource, () => {
        // Delete conversation from reading pane and list view
        deleteConversationStoreUpdate(conversationIdStrings, tableView, 'MarkAsPhishing');
    });
    userMailInteractionAction('MarkAsPhishing', instrumentationContexts);
}
